import {ISerializedWizardFocus, SerializedWizardFocus} from './serializedWizardFocus';
import * as _ from 'lodash';
import {IWizardNode} from './wizardNode';
import {WizardFocus} from './wizardFocus';

export class WizardFocusSerializer {
    static $inject = ['$log'];
    constructor(private $log: angular.ILogService) { }

    public serializeWizardFocus(focus: WizardFocus): ISerializedWizardFocus {
        
        const serialized = new SerializedWizardFocus();
        serialized.nodeStateName = focus.node.stateName;

        // if this focus received its focus from a parent set of records (like a location sub-page working off of a location), grab the index
        if (angular.isDefined(focus.subject) && angular.isUndefined(focus.node.subjectProvider)
            && angular.isDefined(focus.node.parent) && angular.isArray(focus.node.parent.subjectData)) {  
            const parentData = focus.node.parent.subjectData as any[];
            serialized.nodeSubjectIndex = parentData.indexOf(focus.subject);
        }
        return serialized;
    }

    public serializeFocusArray(foci: WizardFocus[]): ISerializedWizardFocus[] {
        return _.map(foci, (item: WizardFocus) => this.serializeWizardFocus(item));
    }

    /**
     * @description NOTE this method will throw exceptions if it is unable to deserialize a node.  An exception means that you will not be able to safely allow the user
     * to pick up where they left off.
     * @param template The template is the list of nodes that the wizard is configured to use.
     */
    public deserializeWizardFocus(template: IWizardNode[], focus: ISerializedWizardFocus): WizardFocus {
        // find the node reference in the template
        const node = this.findNode(template, focus);
        if (angular.isUndefined(node)) {
            this.$log.error('WizardFocusSerializer: could not deserialize wizard focus because it was not found in the node template.', focus, template);
            // we don't usually throw, but we want to catch any error that occurs in setting up the wizard, and just degrade gracefully to letting the user start at the beginning
            // (so if we get some sort of error setting to pick up where you left off, you just end up starting at the beginning).
            throw new Error('WizardFocusSerializer: could not deserialize wizard focus because it was not found in the node template.');
        }

        const result = new WizardFocus(node);
        // now, find the subject, if required
        if (angular.isDefined(focus.nodeSubjectIndex) && focus.nodeSubjectIndex !== null && focus.nodeSubjectIndex >= 0) {
            // if there is a subject index, then we expect parent to have an array of subjectData, and we expect to find our subject in that data
            result.subject = result.node.parent.subjectData[focus.nodeSubjectIndex];
        }
        return result;
    }

    /**
     * @description NOTE this method will throw exceptions if it is unable to deserialize a node.  An exception means that you will not be able to safely allow the user
     * to pick up where they left off.
     * @param template The template is the list of nodes that the wizard is configured to use.
     */
    public deserializeFocusArray(template: IWizardNode[], foci: ISerializedWizardFocus[]): WizardFocus[] {
        return _.map(foci, (item: ISerializedWizardFocus) => this.deserializeWizardFocus(template, item));
    }

    // tree search for target in items
    private findNode(items: IWizardNode[], target: ISerializedWizardFocus): IWizardNode {
        for (const item of items) {
            if (item.stateName === target.nodeStateName)
                return item;
            if (angular.isArray(item.children)) {
                const found = this.findNode(item.children, target);
                if (angular.isDefined(found))
                    return found;    
            }
        }
        return undefined;
    }
}
